"use client";
import React, {useEffect, useState} from "react";
import styles from "../redeem.module.css";
import AddressCom, {AddressData} from "@/app/(redeem)/components/AddressCom";
import {RedeemManager} from "@/Core/Redeem/RedeemManager";
import Load from "@/app/_components/Load/Load";
import {useUser} from "@/app/context/UserContext";
import {RedeemConfigEntity} from "@/Core/Redeem/redeemEntity";
import RouterMgr from "@/Core/RouterMgr";
import BigTips from "@/Master/BigTips";
import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {RedeemConfirmDialogFC} from "@/app/(redeem)/UI/RedeemConfirmDialogFC";
import UserMgr from "@/Core/UserMgr";
import {RedeemCashOutDialogFC} from "@/app/(redeem)/redeemCashOut/RedeemCashOutDialogFC";
import {RedeemAccountDialogFC} from "@/app/(redeem)/redeemAccount/RedeemAccountDialogFC";

export default function RedeemAccountUI() {
    const [isReady, setIsReady] = useState(false);

    const [account, setAccount] = useState('');
    const [accountError, setAccountError] = useState(false);
    const [cAccount, setCAccount] = useState('');
    const [confirmAccountError, setConfirmAccountError] = useState(false);
    const [addressData, setAddressData] = useState<AddressData>({}as AddressData);
    const [guide, setGuide] = useState(false);
    const [configEntity, setConfigEntity] = useState<RedeemConfigEntity>();
    const user = useUser();
    const [selectedHobbies, setSelectedHobbies] = useState<any[]>([
        // {id: 'h1', name: 'card', checked: true},
        // {id: 'h2', name: 'paypal', checked: false},
    ]);
    const [selectedChannel, setSelectedChannel] = useState('');
    const [channelAccount, setChannelAccount] = useState('');

    const handleHobbyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {value, checked} = event.target;
        const copiedArray = [...selectedHobbies];
        for (let i = 0; i < copiedArray.length; i++) {
            const hobby = copiedArray[i];
            if (hobby.name === value) {
                hobby.checked = checked;
            } else {
                hobby.checked = false;
            }
        }
        setSelectedHobbies(copiedArray);
    };

    const addressComChange = (data: { country: string; state: string; city: string }) => {
        console.log('Form Submitted:', data);
        setAddressData(data);
    };

    if (RedeemManager.Instance.isRedeemAccountOk){
        RouterMgr.push('/redeem');
    }

    useEffect(() => {
        if (UserMgr.hasTokenOk(user.token)) {
            setIsReady(true);

            let curAccount = RedeemManager.Instance.getChannelAccount;

            setSelectedChannel(RedeemManager.Instance.selectedChannel);
            setChannelAccount(curAccount);

            setAccount(curAccount);
            setCAccount(curAccount);

            let address = {} as AddressData;
            address.country = RedeemManager.Instance.country;
            address.state = RedeemManager.Instance.state;
            address.city = RedeemManager.Instance.city;
            setAddressData(address);

            console.log('初始化兑换输入配置页面', user);
            RedeemManager.GetRedeemConfig((res: RedeemConfigEntity) => {
                if (res.isOk) {
                    let list = [];
                    for (const resKey in res.typeList) {
                        console.log(res.typeList[resKey]);
                        const data = res.typeList[resKey];

                        if (resKey === '0'){
                            setSelectedChannel(data.channel);
                            RedeemManager.Instance.selectedChannel = data.channel;
                        }
                        list.push({
                            id: resKey,
                            name: data.channel,
                            checked: resKey === '0',
                        });
                    }
                    // setConfigEntity(res);
                    setSelectedHobbies(list)
                } else {
                }
            })
        }
    }, [user]);


    const setRedeemAccount = () => {
        const channel = RedeemManager.Instance.selectedChannel;
        let zipCode = LoginUIManager.getLastUserZipCode;

        if (!account) {
            // BigTips.showMsg('请输入帐号')
            setAccountError(true);
            return;
        }

        if (cAccount != account) {
            // BigTips.showMsg('您的重复确定的帐号不正确')
            setConfirmAccountError(true);
            return;
        }
        if (!addressData?.country) {
            BigTips.showMsg('Unrecognized Country! Please Retype.')
            // BigTips.showMsg('请选择国家')
            return;
        }
        if (!addressData?.state) {
            BigTips.showMsg('Unrecognized State/Province! Please Retype.')
            return;
        }
        if (!addressData?.city) {
            BigTips.showMsg('Unrecognized city! Please Retype.')
            return;
        }
        if (!zipCode){
            BigTips.showMsg('Error Code! Please Retype.')
            // return;
            //todo 测试
            zipCode = '12345678'
        }

        SDialogManagerFC.openDialog(RedeemConfirmDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(RedeemConfirmDialogFC),
            onClose: (isOk:boolean) => {
                  if (isOk) {
                      OnOkSubmit(zipCode, selectedChannel);
                  }
            }
        });

        const OnOkSubmit = (zipCode:string,channel:string) => {
            // RouterMgr.push('/redeemCashOut');
            RedeemManager.Instance.setRedeemAccount(
                account,
                channel,
                addressData?.country,
                addressData?.state,
                addressData?.city,
                zipCode
                )
            // RouterMgr.push('/redeemCashOut');
            SDialogManagerFC.closeDialogFC(RedeemAccountDialogFC)
        }

    }

    return (
        <>
            <div className={styles.redeem_account_wrapper}>
                <section className={styles.section}>
                    <form>
                        {/* 支付方式选择 */}
                        <div className={`${styles.listLogo} center`}>
                            {selectedHobbies.length > 0 ? (selectedHobbies.map(hobby => (
                                <label key={hobby.id}
                                       className={`${styles.logoItem} ${hobby.checked ? styles.curActive : ''} ani`}>
                                    <input type="radio" name="logoType" value={hobby.name}
                                           onChange={handleHobbyChange}/>
                                    <img src={`/img/redeem/icon_${hobby.name}.png`} alt={`icon_${hobby.name}`}/>
                                </label>
                            ))) : (<Load/>)}
                        </div>

                        {/* 信息输入 */}
                        <div className={`${styles.emailBox} ${styles.content}`}>
                            <div className={`center ${styles.eTitle}`}>Your Redemption Details</div>
                            <div className={styles.inputBox}>
                                <div className={`center ${styles.inputItem}`}>
                                    <div className={styles.inputName}>Account:</div>
                                    <div className={`${styles.input} center`}>
                                        <input
                                            className={styles.form_input}
                                            type='text'
                                            placeholder='Enter Your PayPal Email'
                                            value={account}
                                            onChange={e => setAccount(e.target.value)}
                                        />
                                        {accountError && <div className={styles.err}>Invalid email address</div>}
                                    </div>
                                </div>
                                <div className={`center ${styles.inputItem}`}>
                                    <div className={styles.inputName}>Confirm Account:</div>
                                    <div className={styles.input}>
                                        <input type='text' placeholder='Confirm Your PayPal Email'
                                               value={cAccount}
                                               onChange={e => setCAccount(e.target.value)}
                                               />
                                        {confirmAccountError && <div className={styles.err}>Account do not match</div>}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.info}>Please input the correct PayPal account and ensure it's
                                activated, or redemption may fail or be delayed.
                            </div>
                        </div>

                        {/* 地址信息输入 */}
                        <div className={`${styles.content} ${styles.addressBox} `}>
                            <div className={`center ${styles.eTitle}`}>Your Billing Address</div>

                            {/*{JSON.stringify(addressData)}*/}
                            <AddressCom initData={addressData} onChange={(data)=>{
                                setAddressData(data)
                            }}/>
                        </div>
                        {/* 提交按钮 */}
                        <button type="button" className={`btn ${styles.btn}`} onClick={setRedeemAccount}>Confirm
                        </button>

                    </form>
                </section>
            </div>
        </>
    )
}
